export default __webpack_public_path__ + "static/media/redDoor.f82c492b.gif";